"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  home: {
    ok: '确定',
    No: '序号',
    title: '首页',
    description: '这是首页。',
    welcome: '欢迎来到首页！',
    importOne: '换单时间及费用查询',
    importTwo: '进口货物查询',
    importThree: '换单预约',
    importFour: '换单预约历史',
    importFive: '换单预约(上海)',
    importSix: '换单预约历史(上海)',
    controlOne: '订舱',
    controlTwo: '我的订舱',
    controlThree: '订舱(日本)',
    controlFour: '订舱历史(日本)',
    controlFive: 'VGM申报',
    controlSix: '危险品申报',
    controlSeven: '新舱单EDI',
    controlEight: '新舱单EDI反馈',
    controlNine: '我的订舱模板',
    infoOne: '货物跟踪',
    infoTwo: '放单/换单查询',
    infoThree: '危险品/特种箱查询',
    infoFour: '附加费及杂费',
    infoFive: '碳排放计算器',
    infoSix: '文档下载',
    containerOne: '用箱费用查询',
    containerTwo: '箱净重查询',
    containerThree: '滞期费费率查询',
    containerFour: '滞期费计算器',
    vesselOne: '船期查询',
    vesselTwo: '船舶动态&汇率',
    vesselThree: '船舶资料',
    blNo: '提单号',
    blNoMultiple: '多提单号查询时，请使用英文逗号隔开',
    bkNoMultiple: '多订舱号查询时，请使用英文逗号隔开',
    registerNewAccount: '注册新用户',
    registerText: '请填写个人信息',
    account: '账号',
    userName: '用户名',
    passWord: '密码',
    surePassWord: '确认密码',
    email: '邮箱',
    emailPlus: '邮箱 （可收到提单样本邮件）',
    agreeRegisterText: '同意SITC SHIPPING注册及使用相关条款',
    registerAgreement: '注册条款',
    bookingAgreement: '网上订舱使用条款',
    agreement: '已阅读并同意',
    messAgreeRegisterText: '请先同意SITC SHIPPING注册及使用相关条款!',
    messageOne: '请再次输入密码',
    messageTwo: '两次输入密码不一致!',
    messageThree: '请输入正确的邮箱地址',
    messageFour: '请输入正确的用户名',
    messageSix: '请输入邮箱',
    newPassWord: '新密码',
    captchaCode: '验证码(半角英数字)',
    buttonClose: '关闭',
    sentEmail: '发送邮件',
    registerAccount: '注册账号',
    forgetPassword: '忘记密码',
    forgetAccount: '忘记账号',
    rembermer: '记住密码',
    haifeng: '海丰员工',
    portOfDeparture: '起运港',
    destinationPort: '目的港',
    portOfDepartureBySort: '装货港=>卸货港',
    through: '直达',
    transfer: '中转',
    portofTransshipment: '中转港',
    select: '请选择',
    search: '查询',
    reset: '重置',
    connection: '口岸联系方式',
    route: '航线',
    vesselAndVoyage: '船名航次',
    sailingTime: '开航时间',
    arrivalTime: '抵港时间',
    operate: '操作',
    startShipment: '起运',
    aimPort: '目的',
    bookingPromotion: '订舱(推广)',
    departure: '预计离港时间',
    arrival: '预计抵港时间',
    home: '首页',
    schedule: '船期',
    information: '信息查询',
    equipment: '箱管',
    inBound: '进口',
    booking: '订舱',
    suggest: '投诉与建议',
    branch: '分支机构',
    registerIndex: '注册',
    noLogin: '未登录',
    setOut: '出发',
    arrive: '到站',
    vesselName: '船名',
    vesselNameCopy: '船舶名称',
    filter: '筛选',
    submitRegister: '提交注册',
    messAccountNo: '请输入账号',
    messRegisterSuccess: '恭喜您账号注册成功，请前往邮箱激活账号。账号激活后，才可以登录使用。',
    changePasswordTip: '您当前使用的是旧的网上订舱账号，第一次登录新网上订舱需要重置密码才能继续下面的操作',
    readWebOnlineTerm: '阅读条款',
    messagePass: '密码，8<=密码长度<=30，必须包含大写字母+小写字母+数字+特殊符号（!@#￥%&）',
    messagePassAccount: '账号不可重复，5<=账号长度<=20，大写字母+数字 ，必须以大写字母开头',
    modifyPasswordSuccess: '修改成功，请重新登录系统，谢谢！',
    messRegisterFail: '注册失败',
    selectVesselTime: '选择船期',
    mobilePhone: '订舱电话',
    contactCustomer: '订舱负责人',
    people: '实际发货人',
    bkNo: '订舱号',
    bookingType: '订舱类型',
    transportationTerms: '运输条款',
    paidPalce: '付费地点',
    paidType: '付费方式',
    documentType: '单证类型',
    documentNo: '海运单协议号',
    agreementNo: '船开前协议号',
    ft: 'F/T审批号',
    sales: '业务员',
    stuffType: '装箱类型',
    cargoType: '货物类型',
    customsType: '海关类型',
    por: '起始港',
    pol: '装货港',
    pod: '卸货港',
    del: '目的港',
    customerInfoPort: '港口：',
    customerInfoPortType: '港口类型：',
    customerInfoCustomerType: '收发通：',
    customerInfoRequiredField: '必填字段：',
    customerInfoShouldInclude: '应该包含：',
    canNotNull: '不能为空！',
    customerInfoPortFrom: '程次起运港',
    customerInfoPortTo: '程次抵达港',
    address: '地址',
    saveValidCustomerInfoNotification: '通知',
    tips: '提示：',
    compulsion: '强制：',
    continueSave: '继续保存',
    cargoInfo: '货物信息',
    fwdDesc: '货描',
    actualGrossWeight: '毛重(KG)',
    dropTitle: '下货纸箱信息',
    terminalInfo: '场站信息',
    terminalInfoPrevious: '场站信息(上一个版本)',
    terminalInfoCurrent: '场站信息(当前版本)',
    containerType: '箱型',
    quantity: '数量',
    retureDate: '还箱日期',
    pickUpDate: '提箱日期',
    returnDepot: '还箱堆场',
    pickUpDepot: '提箱堆场',
    pickupYard: '提箱地',
    returnYard: '还箱地',
    additionalCharges: '附加费与杂费',
    additionalChargesPrevious: '附加费与杂费(上一个版本)',
    additionalChargesCurrent: '附加费与杂费(当前版本)',
    bKDocumentPrevious: 'BK Document(上一个版本)',
    bKDocumentCurrent: 'BK Document(当前版本)',
    feeItem: '费项',
    payModel: '付费方式',
    documentNoNew: '许可证号码',
    validateFee1: '附加费与杂费中第',
    validateFee2: '行，费项',
    validateFee3: '，已存在！',
    packageCount: '件数',
    packageType: '包装类型',
    weight: '重量',
    useTimes: '第几次使用',
    isSplit: '是否分开',
    tsFlag: '中转',
    addBySchedule: '选船期追加路径',
    tsRoute: '路径',
    dgCheckFlag: '危险品',
    rfCheckFlag: '冷箱信息',
    akCheckFlag: '特种箱信息',
    socCheckFlag: 'SOC',
    hgCheckFlag: '挂衣箱',
    addTransfer: '中转信息',
    tripNumber: '程次',
    portFrom: '起始港',
    portTo: '抵达港',
    voyageLeg: '航段',
    carrier: '承运人',
    lineType: '干支线',
    serviceLineCode: '航线',
    vesselCode: '船舶代码',
    voyageNo: '航次',
    saillingDate: '开航时间',
    etd: '抵港时间',
    polYard: '装港码头',
    podYard: '卸港码头',
    imoClass: 'IMO Class',
    unNo: 'UN No',
    commodityName: '运输品名',
    unit: '单位',
    maxTemperature: '最高温度',
    minTemperature: '最低温度',
    airvent: '通风口',
    humidness: '湿度',
    akGrossWeight: '总重/单箱(KG)',
    akNetWeight: '净重/单箱(KG)',
    quantityNew: '箱量',
    commodityNameNew: '品名名称',
    overFront: '前超*后超*左超*右超*超高(cm)',
    isWallsFold: '挡板是否折叠',
    isPointCover: '吊点是否遮挡',
    stowageRequired: '特殊积载要求',
    specialLoadRequired: '特殊装卸要求',
    securingMethod: '绑扎方式',
    cellphone: '联系方式',
    oceanFreight: '运费',
    direction: '方向',
    returnToPort: '还箱港代码',
    returnToPortName: '还箱港名称',
    fullEmptyType: 'SOC空重类型',
    containerSize: '箱尺寸',
    containerManager: '箱属公司',
    contactPerson: '联系人',
    rope: '绳子',
    ties: "绳结个数",
    type: '类型',
    priceRemark: '价格备注',
    buttonAdd: '保存并提交',
    buttonCopy: '批量拷贝',
    back: '拒绝',
    priceRemarkInfo: '市场价格请备注OF价格，长期合约请备注具体的长期合约号，FOB货请备注具体的FOB号。',
    buttonSaveCopy: '保存草稿',
    placehold: '请输入内容',
    packageDesc: '包装种类',
    property: '运输品名',
    componentDesc: '化学品名',
    emergencyTelNo: '紧急联系方式',
    imoQuantity: '件数',
    imoGrossWeight: '毛重(KG)',
    imoNetWeight: '净重(KG)',
    flashPoint: '闪点',
    rateBase: '闪点单位',
    isPolutionFlag: '是否海污',
    packagingCode: 'Packaging Code',
    cargoSize: '尺寸(立方米)',
    temperatureOne: '温度',
    intakeNum: '通风口',
    contactName: '联系人姓名',
    contactNumber: '联系人电话',
    contactTypeCode: '通讯方式代码',
    approveKey: '快速审批密钥',
    emergencySeq: '应急措施编号',
    unitTitle: '长*宽*高*(CM)',
    startTime: '起始时间',
    endTime: '结束时间',
    form: '至',
    remark: '备注',
    bookingStatus: '订舱状态',
    sureBooking: '确认订舱',
    editBooking: '修改申请',
    cancelBooking: '取消订舱',
    waitBooking: '等待订舱',
    lockBooking: '锁定',
    unlockBooking: '解锁',
    draftBooking: '草稿',
    applyBooking: '申请',
    recordBooking: '补料申请',
    draftRecordBooking: '补料草稿',
    submit: '提交',
    batchCommit: '批量提交',
    lookOne: '查看/编辑',
    lookEdit: '编辑',
    supply: '补料',
    more: '更多',
    bookMyOne: '放单申请',
    bookMyTwo: '船名航次调整',
    bookMyThree: 'CUT TIME',
    bookMyFour: 'Document Import(KR)',
    bookMyFourCopy: 'Document Excel(KR)',
    bookMyFive: '导入格式下载',
    bookMySix: '箱信息&VGM Excel导入',
    bookMySeven: 'FREETIME查看',
    bookMyEight: '主分单校验',
    bookMyNine: '货物跟踪',
    sureButton: '确认',
    saveMessage: '保存成功',
    failMessage: '保存失败',
    departureTime: '离港时间',
    newDepartureTime: '最新离港',
    discharge: '卸港',
    editTime: '修改时间',
    manifestType: '舱单类型',
    blNoType: '提单类型',
    totalNo: '总单号',
    boxType: '箱型数量',
    saveSuccess: '保存成功',
    listModel: '列表模式',
    cardModel: '卡片模式',
    operateSuccess: '操作成功',
    warning: '请先选择数据',
    releaseWay: '放单方式',
    releaseApply: '放单申请',
    releaseView: '电放保函预览',
    porFormat: '起始港格式',
    polFormat: '装货港格式',
    podFormat: '卸货港格式',
    delFormat: '目的港格式',
    logStatus: '电放保函状态',
    logInfomation: '电放保函核对信息',
    deliveryDocumentMethod: '单证类型',
    releaseStatus: '放单状态',
    deleteCheck1: '是否清除',
    deleteCheck2: '里面的数据',
    toast0: '特种箱信息中的箱型必须与下货纸箱型匹配！',
    toast1: '挂衣箱信息中的箱型必须与下货纸箱型匹配！',
    toast2: '请输入订舱号',
    toast3: '请输入提单号',
    toast4: '请输入品名名称',
    toastOne: '货类为单挂衣/双挂衣,请勾选挂衣箱并录入相应信息！',
    toastOne_1: '挂衣箱勾选时,货类需为单挂衣/双挂衣！',
    toastTwo: '箱型为FR/OT/OH/FH,特种箱信息需勾选并录入相应信息！',
    toastTwo_1: '特种箱信息勾选时,箱型需为FR/OT/OH/FH！',
    toastThree: '货类为全危/半危/空箱半危时,请勾选危险品并录入相应信息！',
    toastThree_1: '危险品勾选时,货类需为全危/半危/空箱半危！',
    toastFour: '货类为冻货时,冷箱信息需要勾选并录入信息！',
    toastFour_1: '冷箱信息勾选时，货类需要是冻货！',
    toastFive: '下货纸中冻货类型只能选HR和RF箱型!',
    toastSix: '附加费与杂费不能为空!',
    toastSeven: '类型为推广时,下货纸箱信息只能添加一条!',
    toastEight: '类型为推广时,下货纸箱信息的数量只能为1!',
    toastNine: '货物信息和所有箱信息的件重尺不一致',
    copyNumber: '分票份数',
    copyTwo: '+数字',
    copyThree: '+字母',
    copyFour: '*+字母',
    copySubimtButton: '批量拷贝',
    copySubimtButtonOpen: '批量拷贝(推广)',
    loginSuccess: '登录成功',
    noLoginMessage: '请先登录,再进行操作!',
    sentEmailSuccess: '邮件发送成功',
    sentEmailFail: '邮件发送失败',
    userError: '用户名也不可重复，可以英文也可以是中文，长度不超过100',
    total: '汇总',
    terminalInfoOne: '设施代码',
    terminalInfoTwo: '中文名称',
    terminalInfoThree: '英文名称',
    other: '其他',
    country: '国家/地区代码',
    portCodeOne: '港口代码',
    portName: '港口名称',
    portCodeTwo: '港口名称(CN)',
    closeWaring: '温馨提示,别忘了保存哦~',
    closeWaringTwo: '直接关闭',
    close: '关闭',
    copyOne: '拷贝',
    ftExport: '单票F/T申请',
    ftapply: '单票F/T导出',
    reportOut: '合报分出',
    reportOutOne: '分报合出',
    reportOutTwo: '分报分出',
    reportOutThree: '拆单自动确认',
    reportOuFour: '并单自动确认',
    feedcheck: '补料核对',
    withdrawal: '订舱撤回',
    copySuccess: '拷贝成功',
    logOut: '退出',
    logOutMessage: '您确定要退出吗?',
    logOutSuccess: '退出成功',
    sumit: '确定',
    chargeCode: '费用代码',
    chargeName: '费用名称',
    chargeNameCn: '费用名称(CN)',
    submitSuccess: '提交成功',
    closequxiao: '取消',
    nowAdjust: '立即调整',
    consignerInfo: '发货人信息',
    consignerName: '发货人名称',
    consignerAddress: '发货人地址',
    consignerCountry: '国家/地区',
    consignerPhone: '电话',
    consignerFax: '传真',
    consignerEmail: '邮箱',
    consignerEnterpriseCode: '企业代码',
    consignerAEOCode: 'AEO代码',
    consignerReceiveInfo: '收货人信息',
    consignerReceive: '收货人名称',
    consignerReceiveAddress: '收货人地址',
    notifierCity: '城市名称',
    notifierProvince: '省份名称',
    notifierPostalCode: '邮政编码',
    notifierInfo: '通知人1信息',
    notifierName: '通知人1名称',
    notifierAddress: '通知人1地址',
    notifierInfoTwo: '通知人2信息',
    notifierNameTwo: '通知人2名称',
    notifierAddressTwo: '通知人2地址',
    connetName: '联系人名称',
    connetPhone: '联系人电话',
    connetEmail: '联系人邮箱',
    connetFax: '联系人传真',
    shippingMark: '唛头',
    commodityCode: '品名代码',
    commodityNameOne: '品名名称',
    packageDescOne: '包装描述',
    docCommodity: '许可证品名',
    boxInfo: '箱信息',
    containerNo: '箱号',
    sealNo1: '封号1',
    overWeight: '重量(KG)',
    cntrSize: '尺寸(CBM)',
    overLeft: '左超(CM)',
    overRight: '右超(CM)',
    overHeight: '超高(CM)',
    overForeward: '前超(CM)',
    overAftward: '后超(CM)',
    socReture: 'SOC单双程',
    vgmTitle: 'VGM箱信息',
    vgmPeople: 'VGM负责人签名',
    vgmTobu: '同步信息',
    titleOne: '《交通运输部关于执行《1974年国际海上人命安全公约》第VI/2条2015年修正案的通知》',
    titleTwo: '《载货集装箱累加计算法重量验证指南》',
    cargoTypeCode: '货类',
    containerStatus: '箱状态',
    cargoTypeName: '货类名称',
    cargoTypeNameCn: '货类名称CN',
    saillingDateOne: '开航日期',
    departureTimeOne: '预计离港',
    supplyEdit: '编辑补料',
    location: 'VGM称重地点',
    vgmGrossWeight: 'VGM箱总重',
    vgmScale: 'VGM称重单位',
    vgmDate: 'VGM称重时间',
    vgmMethod: 'VGM称重方法',
    selectFile: '选择文件',
    selectFileMessage: '只能上传excel文件',
    selectOneFile: '仅能上传一个文件，如有多个文件，请整理为一个文件再上传。',
    selectSubmit: '提交',
    DownloadExcelTemplate: '点击下载模板',
    releaseViewUpload: '电放保函上传',
    uploadTitle: '上传文件',
    downloadSuccess: '下载成功',
    applyNo: '申请号',
    //    agreementNo:'协议号',
    approvedNo: '审批号',
    ftIsAccepted: '审批状态',
    receipt: '接货地',
    destination: '目的地',
    commodity: '品名',
    containerVolume: '箱型箱量',
    applyReason: '申请理由',
    expectedDeliveryTime: '预计提货时间',
    shipperName: '发货人',
    consigneeName: '收货人',
    isDG: '业务类型',
    rfPlugDays: '冻柜PLUG天数',
    containerTypeCode: '箱型代码',
    demuFreeDays: '方式一 ',
    detenFreeDays: '方式一',
    backCaoga: '返回草稿',
    ftapplyMessage: '申请成功,请等待审批',
    ftapplyMessageCopy: '返回草稿成功',
    vesselNameCn: '船舶名称(CN)',
    expandOthers: '展开其他信息',
    packUpOthers: '收起其他信息',
    packageCode: '包装类型',
    packageName: '包装类型名称',
    packageNameCn: '包装类型名称(CN)',
    customerTypeOne: '发货人不能为空',
    customerTypeTwo: '收货人不能为空',
    customerTypeThree: '通知人1不能为空',
    customerTypeFour: '通知人2不能为空',
    customerTypeFive: '当卸货港为CNYNT或者CNTXG,收发通的国家信息不能为空',
    customerTypeSix: '当卸货港为CNYNT或者CNTXG,收发通的电话信息不能为空',
    customerTypeSeven: '当卸货港为CNYNT或者CNTXG,收发通的企业代码信息不能为空',
    customerTypeTH1: '当装港为泰国港口,收发通的国家信息不能为空',
    customerTypeTH2: '当装港为泰国港口,收发通的电话信息不能为空',
    customerTypeTH3: '当装港为泰国港口,收发通的企业代码信息不能为空',
    customerTypeTH4: '当装港为泰国港口,收货人信息联系名称不为空',
    customerTypeTH5: '当装港为泰国港口,收货人信息联系邮箱不为空',
    customerTypeCN1: '当卸货港为中国港口，收货人电话信息不能为空',
    customerTypeCN2: '当卸货港为中国港口，收货人企业代码信息不能为空',
    customerTypeCN3: '当卸货港为中国港口，收货人邮箱信息不能为空',
    customerTypeCN11: '当卸货港为中国港口，通知人1信息电话不能为空',
    customerTypeCN12: '当卸货港为中国港口，通知人1信息企业代码不能为空',
    customerTypeCN13: '当卸货港为中国港口，通知人1信息邮箱不能为空',
    warningJustOne: '只能选择一条数据',
    myTemplate: '模板名称',
    createTime: '创建时间',
    ftapplyMessageValid: '越南的提单不支持申请!',
    ftapplyMessageValidOne: '没有箱信息不支持申请!',
    selectFileWaring: '请上传文件',
    uploadTitleSuccess: '文件上传成功',
    cargoTypeCodeOne: '货类',
    revocationConfirmMessage: '是否订舱取回？',
    revocationMessage: '订舱撤回成功',
    checkTitle: '主单分单校验',
    statusMessage: '当前状态不可以进行操作',
    copySix: '系统出号',
    getLockByDocMessage: '已单证锁船,无法修改',
    cancelBookingMessage: '订舱取消成功',
    cancelBookingMessageError: '订舱取消失败，订舱号：',
    cancelBookingConfirmMsg: '是否取消订舱？',
    uploadFile: '附件上传',
    fileName: '文件名',
    uploadTime: '上传时间',
    actions: '操作',
    fileUploadOne: '上传',
    fileTitle: '附件',
    deleteFile: '删除',
    downFile: '下载',
    fileMessageTwo: '只能上传一个文件,请先删除',
    deleteMessage: '是否要进行删除',
    deleteSuccess: '删除成功',
    numberLarge2: '分票数至少2条，不允许多于100条',
    cancelButton: '取消',
    addTicket: '分票信息',
    topBl: '总单号',
    temperature: '冻柜温度',
    terminalInfoMessage: '当装货港为青岛时,场站信息不能为空',
    deleteTip: '至少保留一条数据',
    toastTen: '非中转，不能输入两条中转信息!',
    tsPlus: '如果中转打勾，则中转信息必须大于等于两条。',
    toastEleven: '请先进行船期选择!',
    viewLook: '提单预览',
    bookCancel: '取消订舱',
    reportOutWarning: '仅支持确认订舱、解锁、拆单申请 状态的提单进行合报分出操作',
    reportOutOneWarning: '仅支持确认订舱、解锁、并单申请 状态的提单进行分报合出操作',
    reportOutTwoWarning: '仅支持确认订舱、解锁、拆单申请 状态的提单进行分报分出操作',
    onlyOneOrNullWarning: '请选中1条记录，或者不选中记录，才能使用此功能',
    cancelSuccess: '取消成功',
    applySuccess: '申请成功',
    splistWanning: '该票已操作拆并单，无法进行拆并单。',
    copyCountRequire: '请输入拷贝份数',
    bkNoRequire: '请输入订舱号',
    blNoRequire: '请输入提单号',
    blNoRequire2: '提单号不允许为空',
    deleteRequireLengh: '数据必须大于等于2条',
    pleaseWriteBlno: '请填写提单号或箱号',
    hsCodeOne: 'POL属于KR，HS CODE(KR)、HS CODE(CN)、HS CODE(JP)不可以为空',
    hsCodeTwo: 'POL属于KR，HS CODE(KR)、HS CODE(CN)、HS CODE(JP)不可以为空',
    hsCodeThree: 'POL属于KR，HS CODE(KR)、HS CODE(CN)、HS CODE(JP)不可以为空',
    hsCodeFour: 'HS CODE不可以为空',
    emailRequire: '请输入有效的邮箱地址',
    commodityNameCn: '品名名称(CN)',
    uploadFiveInfo: '上传文件不能超过5MB',
    uploadSixInfo: '文件名过长，请控制在40个字符内！',
    ftboxMessage: '通风口单位必须为%、CBM/H或者CLOSED',
    ftboxMessageOne: '总重包含：货物重量，绑扎材料重量，箱重',
    bookEta: '装货港预计离港',
    //ETA
    bookEtd: '装货港最新离港',
    //ETD
    bookAtd: '卸货港ETA',
    //ATD
    exportTitle: '导出',
    exportMessage: '请先查询数据',
    viewTemplate: '预览',
    sOView: 'SO预览',
    previewFailed: '预览失败，请联系系统管理员。',
    validateTemperature: '温度格式不正确',
    validateIntakeNum: '通风口单位必须为 “%”、"CBM/H" 或 "CLOSED"',
    validateHumidity: '湿度单位必须为"%"',
    viewFail: '当前数据不可进行预览',
    selectSort: '选择列',
    warningRelease: '船名航次 或者 提单号不能都为空！',
    passWordError: '密码长度不能超过30位',
    statusPrintMessage: '暂不支持查看',
    basicInfoPreviousVersion: '基础信息(上一个版本)',
    basicInfoNextVersion: '基础信息(当前版本)',
    consignerInfoPrevious: '发货人信息(上一个版本)',
    consignerInfoCurrent: '发货人信息(当前版本)',
    consignerReceiveInfoPrevious: '收货人信息(上一个版本)',
    consignerReceiveInfoCurrent: '收货人信息(当前版本)',
    notifierInfoPrevious: '通知人1信息(上一个版本)',
    notifierInfoCurrent: '通知人1信息(当前版本)',
    notifierInfoTwoPrevious: '通知人2信息(上一个版本)',
    notifierInfoTwoCurrent: '通知人2信息(当前版本)',
    cargoInfoPrevious: '货物信息(上一个版本)',
    cargoInfoCurrent: '货物信息(当前版本)',
    dropTitlePrevious: '下货纸箱信息(上一个版本)',
    dropTitleCurrent: '下货纸箱信息(当前版本)',
    boxInfoPrevious: '箱信息(上一个版本)',
    boxInfoCurrent: '箱信息(当前版本)',
    detailVerifyMessage: '请先录入补料信息',
    searchMessage: '订舱号、提单号、船名航次和开航时间，不能都为空，必须填其中一项',
    lookOneSupply: '查看/编辑补料',
    sliderText: '拖动滑块完成拼图验证',
    failText: '验证失败，请重试',
    successText: '验证通过',
    rateBaseOne: '单位',
    etdTo: '抵港时间',
    warningReleaseView: '请先选择数据',
    warningLogStateUpload: '所选数据已通过，不允许再次上传',
    agreementNoOne: '协议号',
    containerVolumeOne: '箱型箱量',
    serviceSupport: '帮助中心',
    contactUs: '联系我们',
    helpCenter: '用户注册',
    localContact: '联系方式',
    complaintCenter: '投诉平台',
    blNoTypeOne: '提单类型',
    dgCheckFlagOne: '危险品',
    saveSuccessSubmit: '保存并提交成功',
    ourTitle: '关于我们',
    toastNumber: '程次信息中序号不连贯！',
    toastNumberOne: '程次信息序号不能为空！',
    toastOneFont: '下货纸信息不可以重复，重复数据数量自行累加。',
    lookDetail: '显示详情',
    hideDetail: '收起详情',
    dangerousGoodsMessage: '当危险品IMO Class为3开头,危险品的闪点 和 闪点单位必填',
    messageFourOne: '必须要有一条干线',
    helpNew: '帮助',
    annunciation: '通告',
    evenlyDivide: '均分件重尺',
    countInfo: '统计',
    totalInfo: '合计',
    displayButton: '收发通信息',
    hideButton: '收发通信息',
    displayOpen: '展示',
    displayClose: '收起',
    applicationRules: '申请规则：\nDemurrage:场内用箱 (卸船到提重)   Detention:场外用箱 (提重到返空)\n1.以下5个国家，只能申请 DETENTION 这一项，DEMURRAGE不要填写。申请后DEM/DET可以combined 混用。\n印尼/印度/孟加拉/俄罗斯远东/缅甸\n2.申请时只填入数字即可，不要带上单位 (天/DAYS之类的)',
    successRelease: '申请成功',
    KRXXXreleaseApply: 'SEA WAYBILL 和 ORIGINAL 不适用于韩国订舱',
    seaWaybillValid: '只有当单证类型为海运提单时，才能使用放单方式【海运单】！',
    cargoDescMessage: '货物含敏感货物:',
    cargoDescMessage1: ',是否继续保存？',
    saveTip: '提示',
    warningJustOneTwo: '分票数至少2条,不允许多于100条',
    selectOrder: '选择主单',
    order: '主单',
    combinMessage: '并单操作成功',
    closeCombin: '取消并单',
    sureCombin: '确认并单',
    selectOrdermessage: '请选择主单',
    cancelBookingMessageCombin: '仅支持蛇口、南沙、太仓和泰国口岸的并单的主单操作',
    exportCostSlipUpload: '出口费用确认及水单上传',
    appointmentHistorySh: '进口账单及单据上传',
    bittonTop: '等同于收货人',
    pleaseEnterKeyWord: '装货港,卸货港必填，(船舶代码/船名+航次+航段)和开航时间二选一必填',
    newToday: '今天',
    statusCancelMessage: '仅支持 POL = CNSHK / CNNSA / CNTAG / 泰国使用',
    cancellation: '拆单取消',
    rateBaseCopy: '温度单位',
    cancelBookingChangeVVLMessage: '取消订舱状态不能使用【船名航次调整】',
    bookSureCanUse: '订舱状态为确认订舱或者解锁时，才能使用箱信息&VGM Excel导入功能',
    checkCargoGrossWeight1: '订舱类型 / 箱型不是空箱，毛重不能为 0',
    checkCargoGrossWeight2: '订舱类型 / 箱型是空箱，请确认毛重 0 是否正确',
    hsCodeCnNotNull: 'HS CODE 不为空',
    hsCodeJpNotNull: 'HS CODE(JP) 不为空',
    hsCodeNotNull: 'HS CODE(KR) 不为空',
    chargeInfo: '运价信息',
    chargeInfoTitle: '海运费（普通箱）',
    chargeInfoTips1: '单票单箱',
    chargeInfoTips2: '单票Teu上限',
    annunciation1: '公告',
    containerTypeNotTrue: '下货纸信息里箱型只能选运价信息中存在的箱型',
    containerLimitNotTrue: '下货纸信息里总箱量超过最大限制值 ',
    preLockLabel: '预配锁状态',
    preLock: '预配锁',
    prewiredLock: '预配锁定',
    blLock: '舱单锁定',
    downloadCustomsDeclaration: '下载海关申报单',
    CNXMNPreLock: '只有当订舱POL = CNXMN 且 存在箱信息且 订舱状态为确认订舱或者解锁状态下，预配锁定可用！',
    CNXMNBlLock: '只有当订舱POL = CNXMN 且 存在箱信息且 订舱状态为确认订舱或者解锁状态下，舱单锁定可用！',
    CNXMNDownloadCustomsDeclaration: '只有当订舱POL = CNXMN且预配锁定后可用！',
    validateKRXXXBKDocument: 'BK Document须录入！'
  },
  Announcement: {
    title: '公告',
    text1: '尊敬的客户，',
    text2: '当前平台为海丰集运全新电商平台，具体上线功能及范围，如下：',
    text3: '1. 所有公共查询功能',
    text4: 'a. 免注册登入功能：',
    text4_1: '船期查询，船舶动态，货物跟踪等。',
    text5: 'b. 需注册登入功能（邮件激活，但无需认证）：',
    text5_1: 'VGM申报功能等。',
    text6_1: '2. 网上订舱（需注册认证登入）：中国（深圳、青岛、南沙、洋浦、大连、烟台、天津、日照、潍坊、宁波、上海、太仓、张家港、钦州、香港）、泰国、越南、马来西亚、韩国、日本、印尼',
    text6: '的订舱客户先上线使用，其他客户请继续在旧平台使用，具体上线时间另行通知。',
    text7_1: '3. 进口换单预约（需注册认证登入）：中国（深圳、青岛、天津、大连、南沙、洋浦、宁波、上海）',
    text7: '的进口换单预约客户先上线使用，其他客户请继续在旧平台使用，具体上线时间另行通知。',
    text8: '注：网上订舱和进口换单预约上线口岸老客户请使用原账号登入，首次登入会提示要求重新设置密码，如果是新客户，请先注册并申请认证审批后使用。'
  },
  questionNaire: {
    clickEnter: '点击进入详情',
    title: '2025年度SITC客户需求调研',
    text1: '尊敬的客户',
    text2: '感谢您对SITC的大力支持！',
    text3: '烦请百忙之中填写以下调查问卷，让我们更清楚您对我们服务的意见和需求，以便不断提升我们的服务质量！',
    text4: '网站链接填写问卷：',
    text5: '或长按识别微信二维码填写问卷'
  }
};